import { render, staticRenderFns } from "./RobTable.vue?vue&type=template&id=9ffb60ee&scoped=true"
import script from "./RobTable.vue?vue&type=script&lang=js"
export * from "./RobTable.vue?vue&type=script&lang=js"
import style0 from "./RobTable.vue?vue&type=style&index=0&id=9ffb60ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffb60ee",
  null
  
)

export default component.exports